export default __webpack_public_path__ + "92b9e6e920167f40b8a77823035ce5d4.png";